var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "DESIGN"
        ? [
            _c("el-input", {
              staticClass: "disabled-box",
              attrs: {
                size: "small",
                placeholder: _vm.placeholder,
                maxlength: "50",
                "show-word-limit": "",
              },
            }),
          ]
        : [
            !_vm.readerMode || _vm.perm === "E"
              ? _c("el-input", {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: _vm.placeholder,
                    disabled: _vm.perm === "R",
                    maxlength: "50",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm._value,
                    callback: function ($$v) {
                      _vm._value = $$v
                    },
                    expression: "_value",
                  },
                })
              : _c("div", { staticClass: "form-item-text" }, [
                  _vm._v(_vm._s(_vm._value)),
                ]),
          ],
      _vm.isReplacement
        ? _c(
            "div",
            {
              staticClass: "total-time-con",
              class: { "show-label": _vm.perm === "R" },
            },
            [
              _c("span", { staticClass: "text" }, [_vm._v("本月已补卡次数：")]),
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.cardCount)),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }